import { ChakraFlex, FAIconName, FireflyButton } from '@equip.health/ui';

interface AccordionFooterProps {
  primaryButtonTittle: string;
  onPrimaryButtonClick: () => void;
  secondaryButtonTitle?: string;
  onSecondaryButtonClick?: () => void;
  primaryIconName?: string;
  secondaryIconName?: string;
  id: string;
  isPrimaryButtonDisabled?: boolean;
}

const AccordionFooterButtons = ({
  primaryButtonTittle,
  onPrimaryButtonClick,
  secondaryButtonTitle,
  onSecondaryButtonClick,
  primaryIconName,
  secondaryIconName,
  id,
  isPrimaryButtonDisabled,
}: AccordionFooterProps) => {
  return (
    <ChakraFlex alignItems="center" justify="space-between" width="100%">
      <FireflyButton
        id={`${id}__accordion_secondary_action`}
        leftIcon={secondaryIconName as FAIconName} //TODO the props as FAIconName and use the enum
        onClick={onSecondaryButtonClick}
        variant="secondary"
      >
        {secondaryButtonTitle}
      </FireflyButton>

      <FireflyButton
        id={`${id}__accordion_primary_action`}
        isDisabled={isPrimaryButtonDisabled}
        leftIcon={primaryIconName as FAIconName} //TODO the props as FAIconName and use the enum
        onClick={onPrimaryButtonClick}
      >
        {primaryButtonTittle}
      </FireflyButton>
    </ChakraFlex>
  );
};

export default AccordionFooterButtons;
